const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/frame/footer.jsx";import React from "react";
import { Container, Col, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import footerImage from "../../../public/shared/footer.png";

const Footer = () => {
    const { t } = useTranslation();

    return (
        React.createElement(Container, { className: "bg-white", fluid: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 10}}
            , React.createElement('div', { className: "d-flex justify-content-between" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}}
                , React.createElement(Col, { lg: 8, xs: 0, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
                    , React.createElement(Image, {
                        src: footerImage,
                        alt: "logo",
                        className: "d-none d-md-block mt-3"  ,
                        style: {
                            bottom: "0",
                            left: "0",
                            width: "50%",
                            objectFit: "cover",
                        }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
                    )
                )
                , React.createElement(Col, {
                    lg: 4,
                    xs: 12,
                    className: "d-flex flex-column justify-content-end"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}

                    , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
                        , React.createElement('div', {
                            className: "text-pri font-h3 m-3"  ,
                            style: { whiteSpace: "pre-line" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}

                            , React.createElement('div', { className: "text-color-ms fw-bold text-right"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
                                , t("footer.title")
                            )
                            , React.createElement('div', { className: "text-color-ms ml-2 mt-1 text-right"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
                                , t("footer.organization")
                            )
                        )
                    )
                )
            )
        )
    );
};

export default Footer;
